import React from "react";
import styled from "styled-components";

type Props = {
    district: string;
    province: string;
    subDistrict: string;
    postalCode: string;
};

const AddressOption = ({
    subDistrict,
    district,
    province,
    postalCode,
}: Props) => (
    <DivStyled className="address-option">
        <div>
            <span>{subDistrict}, </span>
            <span>{district}, </span>
            <span>{province}, </span>
            <span>{postalCode}</span>
        </div>
    </DivStyled>
);

const DivStyled = styled.div`
    &.address-option {
        div > span {
            margin-right: 4px;
            white-space: break-spaces;
            word-break: break-word;

            &:last-child {
                margin-right: 0px;
            }
        }
    }
`;

export default AddressOption;
